export default (phone: string): string => `tel:${phone.replace(/[^+\d]/g, '')}`;
